import { Appointment, TaskListItem } from '@myapp/contract'
import { AlertCircle, ChevronRight } from 'lucide-react'
import { workOrderAddress } from '../../../../shared/helpers/address'
import Modal from '../../../../shared/ui/overlay/Modal/Modal'

interface Props {
  show: boolean
  setShow: (show: boolean) => void
  appointments: Appointment[]
  tasks: TaskListItem[]
  onAppointmentClick: (id: number) => void
  onTaskClick: (id: number) => void
}

function formatHHmm(iso: string): string {
  const d = new Date(iso)
  const h = String(d.getHours()).padStart(2, '0')
  const m = String(d.getMinutes()).padStart(2, '0')
  return `${h}:${m}`
}

export function UnclosedItemsReminderModal({
  show,
  setShow,
  appointments,
  tasks,
  onAppointmentClick,
  onTaskClick,
}: Props) {
  return (
    <Modal show={show} setShow={setShow} title="Noch nicht abgeschlossen">
      <div className="flex flex-col gap-4 w-full">
        {appointments.length > 0 && (
          <div className="flex flex-col gap-1.5">
            <span className="text-[11px] font-medium text-red-600 uppercase tracking-wide">
              Termine
            </span>
            {appointments.map((a) => (
              <div
                key={a.id}
                className="flex items-center gap-2.5 bg-white rounded-lg shadow-sm border border-red-200 border-l-4 px-3 py-2 cursor-pointer hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 select-none"
                style={{ borderLeftColor: '#DC2626' }}
                onClick={() => onAppointmentClick(a.id)}
              >
                <AlertCircle size={15} color="#DC2626" className="shrink-0" />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-gray-800 truncate leading-tight">
                    {workOrderAddress(a.workOrder?.external) ?? a.id}
                  </p>
                  <p className="text-xs text-gray-500 leading-tight">
                    {formatHHmm(a.schedule.plannedWorkStartsAt)} Uhr
                  </p>
                </div>
                <ChevronRight size={15} className="shrink-0 text-gray-400" />
              </div>
            ))}
          </div>
        )}

        {tasks.length > 0 && (
          <div className="flex flex-col gap-1.5">
            <span className="text-[11px] font-medium text-red-600 uppercase tracking-wide">
              Aufgaben
            </span>
            {tasks.map((t) => (
              <div
                key={t.id}
                className="flex items-center gap-2.5 bg-white rounded-lg shadow-sm border border-red-200 border-l-4 px-3 py-2 cursor-pointer hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 select-none"
                style={{ borderLeftColor: '#DC2626' }}
                onClick={() => onTaskClick(t.id)}
              >
                <AlertCircle size={15} color="#DC2626" className="shrink-0" />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-gray-800 truncate leading-tight">
                    {t.title}
                  </p>
                  {t.schedule?.plannedWorkStartsAt && (
                    <p className="text-xs text-gray-500 leading-tight">
                      {formatHHmm(t.schedule?.plannedWorkStartsAt)} Uhr
                    </p>
                  )}
                </div>
                <ChevronRight size={15} className="shrink-0 text-gray-400" />
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  )
}
